import get from 'lodash.get';

const getUserPreferences = (rootState) => get(rootState, 'user.userPreferences', null);

export default getUserPreferences;
